class RatingBarController {
    $onInit() {
        this.ratingCountText = this.starData.count || '-';
    }
}

const ratingBarComponentDefinition = {
    controller: RatingBarController,
    template: require('./rating-bar.component.html').trim(),
    bindings: {
        starData: '<',
    },
};

module.exports = {
    RatingBarController,
    ratingBarComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/rating/rating-bar.component.js